module.exports = __webpack_public_path__ + "img/header.c9d6b9a5.png";